import { render, staticRenderFns } from "./NovaPoshtaTableUser.vue?vue&type=template&id=006afdb4&scoped=true"
import script from "./NovaPoshtaTableUser.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006afdb4",
  null
  
)

export default component.exports